import "./ContactSupport.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import RequestATechnicalQuote from "./sections/RequestATechnicalQuote";
import WhyThisIntensive from "./sections/WhyThisIntensive";
import LocationAndServiceAreasRepairService from "@/reusable_sections/Footer";
export default function ContactSupportPage() {
  return <div>
      <VoltMainHeader />
      <RequestATechnicalQuote />
      <WhyThisIntensive />
      <LocationAndServiceAreasRepairService />
    </div>;
}